import { Box, Spinner } from '@shopify/polaris';
import React from 'react';
import ShopifyModal from '../ShopifyModal';
import './index.css';

const Index = ({
  width,
  loading,
  buttonLoading,
  title,
  content,
  open,
  onClose,
  cancel,
  disabled,
  save,
  button,
}) => {
  return (
    <ShopifyModal
      id="common-modal"
      open={open}
      heading={title}
      onClose={onClose}
      showCloseButton={!button}
      size={width ? 'large' : 'base'}
      secondaryActions={
        button
          ? {
              content: cancel,
              onAction: onClose,
            }
          : undefined
      }
      primaryAction={
        button
          ? {
              content: save,
              onAction: onClose,
              disabled,
              loading: buttonLoading,
            }
          : undefined
      }
    >
      <Box className="common_modal_content" style={width ? { width } : undefined}>
        {loading ? (
          <Box className="common_modal_content_loading">
            <Spinner accessibilityLabel="Spinner example" size="large" />
          </Box>
        ) : (
          <Box className="common_modal_content_box">{content}</Box>
        )}
      </Box>
    </ShopifyModal>
  );
};

export default Index;
